import { createFileRoute, useLoaderData } from "@tanstack/react-router";

import { eventsApiClient, orgApiClient } from "@/libs/api";

import { EventDetailPage as EventDetailPageComponent } from "./-components/event-detail.page";

export const Route = createFileRoute("/org/$orgId/event/$eventId")({
  component: EventDetailPage,
  loader: async ({ params }) => {
    const org = await orgApiClient.getFullDetail(params.orgId);
    const event = await eventsApiClient.getEventById(params.eventId);
    return { data: { org, event } };
  }
});

function EventDetailPage() {
  const {
    data: { org, event }
  } = useLoaderData({ from: "/org/$orgId/event/$eventId" });
  if (!org || !event) {
    return <div>Organization or Event not found</div>;
  }

  return <EventDetailPageComponent org={org} event={event} />;
}
